import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppRoutes } from "src/app/navigation/routes";
import { EYMEMORY_PAGES } from "src/shared/config/src/lib/constants";

type StripeHandlingProps = {
  isSuccessPage: boolean;
};

const StripeHandling: React.FC<StripeHandlingProps> = ({
  isSuccessPage = false,
}) => {
  const navigate = useNavigate();
  const { sessionId = "" } = useParams<{ sessionId: string }>();

  useEffect(() => {
    if (!sessionId) {
      navigate(AppRoutes.EYMEMORIES, {
        state: { redirectTo: `${EYMEMORY_PAGES.error}` },
      });
    }
    navigate(AppRoutes.EYMEMORIES, {
      state: {
        redirectTo: isSuccessPage
          ? `${EYMEMORY_PAGES.paymentSuccess}/${sessionId}`
          : `${EYMEMORY_PAGES.paymentFailure}/${sessionId}`,
      },
    });
  }, []);

  return <></>;
};

export default StripeHandling;
